import { getJSON } from 'redux-api-middleware'
import { normalize } from 'normalizr'
import humps from 'humps'
import immutable from 'object-path-immutable'
import moment from 'moment'

export default function (json, rootKey, schema) {
  return getJSON(json).then((data) => {
    var humped = humps.camelizeKeys(data)

    if (!humped) {
      return {}
    }

    const meta = humped.meta
    humped = humped[rootKey]

    const normalized = normalize(humped, schema)

    return autoParseDateTimes({ ...normalized, meta })
  })
}

function autoParseDateTimes (normalized) {
  var { entities } = normalized

  Object.keys(entities).forEach(entityName => {
    Object.keys(entities[entityName]).forEach(entityId => {
      const entity = entities[entityName][entityId]

      Object.keys(entity).forEach(attributeName => {
        if (attributeName.endsWith('At') || attributeName.endsWith('On') || attributeName.endsWith('Date')) {
          const keyPath = [entityName, entityId, attributeName]
          var dateTime = null

          if (entity[attributeName]) {
            dateTime = moment(entity[attributeName])
          } else {
            dateTime = null
          }

          entities = immutable.set(entities, keyPath, dateTime)
        }
      })
    })
  })

  return {
    ...normalized,
    entities
  }
}



// WEBPACK FOOTER //
// ./src/helpers/deserialize.js